// 가로 스와이프 감지 — 달력/시간표의 이전·다음 이동용.
// 세로 스크롤 중 손가락이 약간 옆으로 흘러도 이동하지 않도록, 가로 이동이 세로보다
// 확실히 클 때(DOMINANCE배)만 스와이프로 본다. 두 손가락(확대/축소)은 무시한다.
import { useRef } from "react";

const MIN_DISTANCE = 50;
const DOMINANCE = 1.5;

// onSwipe(step): step = +1(다음, 왼쪽으로 밀기) / -1(이전, 오른쪽으로 밀기)
export default function useHorizontalSwipe(onSwipe) {
  const start = useRef(null);

  const onTouchStart = (e) => {
    start.current = e.touches.length === 1
      ? { x: e.touches[0].clientX, y: e.touches[0].clientY }
      : null;
  };

  const onTouchEnd = (e) => {
    if (!start.current) return;
    const dx = start.current.x - e.changedTouches[0].clientX;
    const dy = start.current.y - e.changedTouches[0].clientY;
    start.current = null;
    if (Math.abs(dx) < MIN_DISTANCE || Math.abs(dx) < Math.abs(dy) * DOMINANCE) return;
    onSwipe(dx > 0 ? 1 : -1);
  };

  return { onTouchStart, onTouchEnd };
}
